import { Grid, Checkbox, Typography } from '@mui/material'
import React from 'react'
import { KaziAvatar } from '../../../Shared Components/Kazi/KaziAvatar'
import { formatUserName, toPascalCase } from '../../../Utils/String';

interface RecepientProps {
    user: any;
    selectedRecepient: any;
    handleCheck: (prop: string) => void
}
export const Recepient = ({ user, selectedRecepient, handleCheck}: RecepientProps) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <Grid display={'flex'} flexDirection={'row'} gap={1}>
                <Checkbox 
                    sx={{
                        width:'24px',
                        '&.MuiCheckbox-root.Mui-checked': {
                            color: 'primary.main'
                        }
                    }}
                    disabled={selectedRecepient && selectedRecepient.locator !== user.locator || false} 
                    checked={selectedRecepient && selectedRecepient.locator === user.locator} 
                    onChange={() => handleCheck(user)}
                />
                <Grid display={'flex'} flexDirection={'row'} gap={1} >
                    <Grid display={'flex'} flexDirection={'column'} justifyContent={'center'}>
                        <KaziAvatar 
                            locator={user.locator} 
                            first_name={user.first_name} 
                            last_name={user.last_name} 
                            width='32px' 
                            sx={{fontSize: 12}}
                        />
                    </Grid>
                    <Grid display={'flex'} flexDirection={'column'} justifyContent={'center'}>
                        <Typography variant='body-medium'>{formatUserName(user.first_name, user.last_name)}</Typography>
                        <Typography  variant='body-smaller'>{user?.title ?? user?.company ?? ''}</Typography>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}